import { COMPANY_ADDRESS, COMPANY_NAME, LEGAL_NAME, PRIVACY_EMAIL } from "@/constants/company";

const UPDATED = "September 2026";

export default function Privacy() {
  return (
    <div className="max-w-[860px] mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="text-[11px] tracking-luxe uppercase text-aura-muted mb-2">Legal</div>
      <h1 className="font-serif text-4xl tracking-tight mb-2">Privacy Policy</h1>
      <p className="text-xs text-aura-muted mb-8">Last updated: {UPDATED}</p>

      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        {LEGAL_NAME} ("{LEGAL_NAME}", "we", "us"), {COMPANY_ADDRESS}, operates {COMPANY_NAME} at
        shoptosa.com and related services (the "Service"). {COMPANY_NAME} is part of {LEGAL_NAME}. This Privacy Policy explains what
        information we collect, how we use it, and the choices you have. By using the Service
        you agree to this policy.
      </p>

      <h2 className="font-serif text-2xl mt-10 mb-3">Information we collect</h2>
      <ul className="text-sm text-aura-muted leading-relaxed mb-4 list-disc pl-5 space-y-1">
        <li><b>Account information</b> you provide when you register — name, email, and, for sellers, business and payout details.</li>
        <li><b>Content you upload</b> — product photos, listing details, and messages.</li>
        <li><b>Usage data</b> — pages viewed, searches, clicks, device and browser information, and IP address.</li>
        <li><b>Cookies and similar technologies</b> used to keep you signed in, remember preferences, and measure performance.</li>
      </ul>

      <h2 className="font-serif text-2xl mt-10 mb-3">How we use information</h2>
      <ul className="text-sm text-aura-muted leading-relaxed mb-4 list-disc pl-5 space-y-1">
        <li>To operate, maintain, and improve the Service.</li>
        <li>To power AI features such as product discovery, styling, and catalog generation.</li>
        <li>To process transactions, seller listings, and marketplace connections you authorize.</li>
        <li>To communicate with you about your account, updates, and support.</li>
        <li>To detect, prevent, and address fraud, abuse, and security issues.</li>
      </ul>

      <h2 className="font-serif text-2xl mt-10 mb-3">Affiliate links and partner products</h2>
      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        Some products shown on Shoptosa are offered by third-party retailers and brands through
        affiliate partnerships (for example Rakuten Advertising, CJ, Awin, FlexOffers,
        Amazon Associates, eBay Partner Network, Walmart Affiliates, Skimlinks, Target, Best Buy, Admitad, Flipkart Affiliate, and EarnKaro). When you click certain links or complete a purchase on a partner's
        site, we may earn a commission at no additional cost to you. These partners may set cookies
        or use tracking parameters to attribute referrals. Purchases from partner retailers are
        completed on the retailer's own website and are subject to that retailer's terms and privacy
        practices.
      </p>

      <h2 className="font-serif text-2xl mt-10 mb-3">How we share information</h2>
      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        We do not sell your personal information. We share it only with: service providers who
        help us run the Service (e.g., hosting, payments, analytics, AI providers); marketplaces
        and affiliate partners as needed to complete actions you initiate; and authorities where
        required by law.
      </p>

      <h2 className="font-serif text-2xl mt-10 mb-3">Data retention & security</h2>
      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        We retain information for as long as your account is active or as needed to provide the
        Service and meet legal obligations. If eBay notifies us that a connected seller closed
        their eBay account, we delete the eBay tokens and eBay account identifiers we stored for
        that connection. We use reasonable technical and organizational measures
        to protect your data, though no method of transmission or storage is completely secure.
      </p>

      <h2 className="font-serif text-2xl mt-10 mb-3">Your rights</h2>
      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        Depending on your location, you may have the right to access, correct, delete, or export
        your personal information, or to object to certain processing. To exercise these rights,
        contact us at <a href={`mailto:${PRIVACY_EMAIL}`} className="link-underline">{PRIVACY_EMAIL}</a>.
      </p>

      <h2 className="font-serif text-2xl mt-10 mb-3">Children's privacy</h2>
      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        The Service is not directed to children under 16, and we do not knowingly collect their
        personal information.
      </p>

      <h2 className="font-serif text-2xl mt-10 mb-3">Changes to this policy</h2>
      <p className="text-sm text-aura-muted leading-relaxed mb-4">
        We may update this policy from time to time. Material changes will be posted on this page
        with an updated date.
      </p>

      <h2 className="font-serif text-2xl mt-10 mb-3">Contact</h2>
      <p className="text-sm text-aura-muted leading-relaxed">
        Questions about this policy? Email{" "}
        <a href={`mailto:${PRIVACY_EMAIL}`} className="link-underline">{PRIVACY_EMAIL}</a>
        {" "}or write to {LEGAL_NAME}, {COMPANY_ADDRESS}.
      </p>
    </div>
  );
}
